import { Modal, Tag, Descriptions, Divider, Button } from "antd";
import { DownloadOutlined, EyeOutlined } from "@ant-design/icons";
import moment from "moment";
import { API } from "../../../config/API";

const STATUS_COLORS: Record<string, string> = {
  pending: "default",
  sending: "blue",
  completed: "green",
  partial: "orange",
  failed: "red",
};

function ViewModal(props: any) {
  const item = props.item || {};

  const serverBase = (API.BASE_URL || "").replace(/\/api\/?$/, "");
  const attachmentHref = item.attachment_url
    ? `${serverBase}${item.attachment_url}`
    : null;

  const mime = String(item.attachment_mime || "").toLowerCase();
  const isImage = mime.startsWith("image/");
  const isPdf = mime === "application/pdf";

  const emails: string[] = Array.isArray(item.emails) ? item.emails : [];

  return (
    <Modal
      title="Notification Details"
      open={props.open}
      onCancel={props.onClose}
      footer={null}
      width={780}
      destroyOnClose
    >
      <Descriptions column={2} size="small" bordered>
        <Descriptions.Item label="Subject" span={2}>
          <strong>{item.subject}</strong>
        </Descriptions.Item>
        <Descriptions.Item label="Audience">
          <Tag color={item.recipient_type === "all" ? "blue" : "purple"}>
            {item.recipient_type === "all" ? "All Users" : "Epaper Users"}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag color={STATUS_COLORS[item.status] || "default"}>
            {item.status ? item.status.toUpperCase() : "-"}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Total Recipients">
          {item.email_count || 0}
        </Descriptions.Item>
        <Descriptions.Item label="Sent / Failed">
          <span style={{ color: "#16a34a", fontWeight: 500 }}>
            {item.sent_count || 0}
          </span>
          {" / "}
          <span
            style={{
              color: item.failed_count > 0 ? "#dc2626" : "#666",
              fontWeight: 500,
            }}
          >
            {item.failed_count || 0}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="Sent By">
          {item.sent_by || "—"}
        </Descriptions.Item>
        <Descriptions.Item label="Date">
          {item.createdAt
            ? moment(item.createdAt).format("DD MMM YYYY, hh:mm A")
            : "-"}
        </Descriptions.Item>
        {item.error_message ? (
          <Descriptions.Item label="Errors" span={2}>
            <span style={{ color: "#dc2626" }}>{item.error_message}</span>
          </Descriptions.Item>
        ) : null}
      </Descriptions>

      {item.attachment_name && attachmentHref ? (
        <>
          <Divider orientation="left" plain>
            Attachment
          </Divider>
          <div
            style={{
              border: "1px solid #f0f0f0",
              borderRadius: 6,
              padding: 12,
              background: "#fafafa",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
                marginBottom: isImage || isPdf ? 12 : 0,
                flexWrap: "wrap",
              }}
            >
              <div style={{ fontSize: 13, fontWeight: 500, wordBreak: "break-all" }}>
                {item.attachment_name}
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <Button
                  size="small"
                  icon={<EyeOutlined />}
                  onClick={() =>
                    window.open(attachmentHref, "_blank", "noopener,noreferrer")
                  }
                >
                  Open
                </Button>
                <Button
                  size="small"
                  type="primary"
                  icon={<DownloadOutlined />}
                  href={attachmentHref}
                  download={item.attachment_name}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download
                </Button>
              </div>
            </div>
            {isImage ? (
              <img
                src={attachmentHref}
                alt={item.attachment_name}
                style={{
                  maxWidth: "100%",
                  maxHeight: 360,
                  display: "block",
                  margin: "0 auto",
                  borderRadius: 4,
                }}
              />
            ) : isPdf ? (
              <iframe
                title={item.attachment_name}
                src={attachmentHref}
                style={{
                  width: "100%",
                  height: 420,
                  border: "1px solid #e5e7eb",
                  borderRadius: 4,
                  background: "#fff",
                }}
              />
            ) : null}
          </div>
        </>
      ) : null}

      <Divider orientation="left" plain>
        Email Body
      </Divider>
      <div
        style={{
          border: "1px solid #f0f0f0",
          borderRadius: 6,
          padding: 12,
          maxHeight: 240,
          overflow: "auto",
          background: "#fafafa",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          fontSize: 13,
          lineHeight: 1.5,
        }}
      >
        {item.body || ""}
      </div>

      <Divider orientation="left" plain>
        Recipients ({emails.length})
      </Divider>
      <div
        style={{
          border: "1px solid #f0f0f0",
          borderRadius: 6,
          padding: 12,
          maxHeight: 200,
          overflow: "auto",
          background: "#fafafa",
          fontSize: 12,
          fontFamily: "monospace",
          whiteSpace: "pre-wrap",
          wordBreak: "break-all",
        }}
      >
        {emails.length ? emails.join(", ") : "—"}
      </div>
    </Modal>
  );
}

export default ViewModal;
